var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","lg3":""}},[_c('v-select',{attrs:{"items":_vm.alphabet,"label":_vm.$t('app.search')},on:{"input":_vm.emitEventValue}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }